import AwardsImage from '/public/images/awards-v4.webp';
import CloseIcon from '/public/images/close_green.svg';
import GiftBoxIcon from '/public/images/giftbox.svg';
import Image from 'next/image';
import styled from "styled-components";
import {getColor} from "@/styles/ThemeConfig";
import {useEffect, useRef, useState} from "react";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const TourBookingWrapper = styled.div`
    background: #fff;
    padding: 20px 35px;
    max-width: 470px;
    z-index: 20;

    .plugin {
        width: 100%;
        overflow: hidden;
    }

    iframe {
        border: none;
        width: 100%;
        min-height: 200px;
        transition: height 0.3s ease-in-out;
    }

    .close_btn {
        display: none;
        background: url("${CloseIcon?.src}") no-repeat center right;
        width: 16px;
        height: 16px;
    }

    .heading {
        color: #c49959;
        font-size: 24px;
        line-height: 29px;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
        text-transform: uppercase;
    }

    .price {
        color: #859f95;
        font-size: 16px;
        line-height: 24px;
        font-family: 'Josefin Sans', sans-serif;
        margin-top: 10px;

        span {
            color: #144733;
            font-size: 36px;
            line-height: 43px;
            font-family: 'Josefin Sans', sans-serif;
            font-weight: bold;
        }

        span:nth-child(2) {
            position: relative;
            color: #859f95;
            font-size: 26px;
            line-height: 43px;
            font-family: 'Josefin Sans', sans-serif;
            font-weight: bold;
        }

        span:nth-child(2)::after {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 2px;
            background-color: #f25c5c; /* red color */
            transform: rotate(-10deg); /* adjust angle as needed */
            transform-origin: left center;
            pointer-events: none;
        }


    }

    .plugin {
        margin: 20px 0;
    }

    .buy {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        color: #fff!important;
        background: #144733!important;
        text-decoration: none!important;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 1px;
        transition: background .2s linear;

        :hover {
            background: #859f95!important;
        }

        .dollar {
            background: url("${GiftBoxIcon?.src}");
            width: 20px;
            height: 20px;
            margin-right: 15px;
        }
    }


    .text-red,.text-pt{
        font-size: 14px;
    }
    .text-pt-disclaimer{
        font-size: 11px;
    }
    .text-red{
        color:red!important;
    }
    

    .text {
        font-size: 16px;
        line-height: 24px;
        font-family: 'Josefin Sans', sans-serif;
        color: #859f95;
        margin-top: 30px;
    }
    a {
        color: ${getColor('gold')}!important;
        text-decoration: underline;
    }

    @media screen and (max-width: 1450px) {
            right: 0;
    }

    @media screen and (max-width: 1400px) {
            top: -140px;
            //padding: 40px 10px 10px 20px !important;
            max-width: 380px !important;
        padding: 0;

        .price {
            padding-left: 20px;
        }

        .price span {
            font-size: 26px !important;
            line-height: 33px !important;
        }

        .heading {
            padding-left: 20px !important;
        }
    }

    .blue_block{
        background-color: #0a88ff;
        padding: 10px;
        color: #fff!important;
        margin-bottom: 20px;
        a,div,p,span,strong{
            color: #fff!important;
        }
    }
`



const extractIframeData = (embedHtml) => {
    // Create a temporary DOM parser
    const parser = new DOMParser();
    const doc = parser.parseFromString(embedHtml, "text/html");

    // Find the iframe element
    const iframe = doc.querySelector("iframe");
    if (!iframe) return null;

    // Extract src attribute
    const src = iframe.getAttribute("src");

    // Extract JSON options from src hash
    let options = null;
    if (src && src.includes("#options=")) {
        try {
            const jsonString = decodeURIComponent(src.split("#options=")[1]);
            options = JSON.parse(jsonString);
        } catch (error) {
            console.error("Error parsing iframe options:", error);
        }
    }

    return {
        src,
        srcBase: src.split("#")[0], // Remove the #options part
        options,
        widget: options?.widget || null,
        width: options?.width || "370px",
        currency: options?.currency || null,
        eventPeriod: options?.["event-period"] || null,
        channel: options?.channel || null,
        products: options?.products || null,
    };
};

export default function TourBookingSection({embed, price, crossedPrice = null, currency,disabledText, ...rest})
{
    const pluginRef = useRef(null);
    const [scriptData, setScriptData] = useState(null);


    useEffect(() => {
        if (embed) {
            setScriptData(extractIframeData(embed));
        }
    }, [embed]);


    useEffect(() => {
        if (scriptData && pluginRef.current) {
            // Remove existing iframe(s) inside pluginRef
            const existingIframe = pluginRef.current.querySelector("iframe");
            if (existingIframe) {
                existingIframe.remove(); // ✅ Remove old iframe
            }

            // Remove existing script if already injected
            const existingScript = document.getElementById("ticketinghub-script");
            if (existingScript) {
                existingScript.remove(); // ✅ Remove old script
            }

            // Inject the TicketingHub checkout script dynamically
            const script = document.createElement("script");
            script.src = "https://assets.ticketinghub.com/checkout.js";
            script.setAttribute("data-widget", scriptData.widget); // Set extracted widget
            script.setAttribute("data-width", scriptData.width); // Set extracted width
            script.id = "ticketinghub-script";
            script.async = true;

            pluginRef.current.appendChild(script);
        }
    }, [scriptData]);



    return <TourBookingWrapper id={'BOOKING'} {...rest}>
        <div className="heading no-mobile">Book Your Tour</div>


        {
            disabledText && <div className={'blue_block'} dangerouslySetInnerHTML={{__html:disabledText}}/>
        }


        {
            (price) && <div className="price no-mobile">
                <span>{currency ?? '€'}{price}</span> {crossedPrice && <span>{currency ?? '€'}{crossedPrice}</span>} / person
            </div>
        }


        {/*<div dangerouslySetInnerHTML={{__html: embed}}/>*/}

        {/* TicketingHub widget loads here */}
        <div ref={pluginRef} className="plugin"></div>

        <div className="text-red">If you have any issues with payment, please email us at <ForceSSRLink
            href="mailto:contact@secrettours.com">contact@secrettours.com</ForceSSRLink> with the city, date and time of tour, and
            how many adult and child's tickets you need so we can assist you.
        </div>
        <p className="text-pt"><strong>If a tour is fully booked, or you are looking to book a *Group or Private Tour -
            please email us about <ForceSSRLink href="/private-bookings">Group &amp; Private Tours</ForceSSRLink> options.</strong></p>
        <p className="text-pt-disclaimer">*Please note - Group &amp; Private Tours are specifically organised for your
            group and therefore subject to a premium price. </p>
        <div className="awards-desktop">
            <Image src={AwardsImage} alt="Awards" width="600" height="200" style={{
                width: '100%', height: 'auto', objectFit: 'contain',
            }}/>
        </div>
        <ForceSSRLink href="/buy-gift/" className="buy"><span className="dollar"></span>Buy as a gift</ForceSSRLink>

    </TourBookingWrapper>
}
